export const saldoRecebimentoCorteOption = [
  { label: 'FECHADO', value: 'F' },
  { label: 'POSITIVO', value: 'P' },
  { label: 'NEGATIVO', value: 'N' },
];
